<template>
  <v-card
    class="mx-auto"
    max-width="100%"
    flat
    :to="navigateToSurveyDetails(item)"
    :style="`border-top: 15px solid var(--v-primary-base)`"
  >
    <v-card-text class="pt-0 pb-0">
      <!--<v-list two-line>
      <v-list-item-group v-model="selected" active-class="primary--text">
        <template v-for="(item, index) in pollSurveyQuestions"> -->
      <!-- {{ item }} -->
      <v-toolbar flat height="33">
        <a-chip
          x-small
          color="Neutral"
          style="border: 1px solid var(--v-secondary-base) !important"
        >
          {{
            item.type === "survey" ? $t("poll.btnSurvey") : $t("poll.btnPoll")
          }}
        </a-chip>
        <v-spacer></v-spacer>
        <RespondedMsg v-if="item.user_responded"></RespondedMsg>
        <v-spacer></v-spacer>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-if="$security.checkUserAccess('UpdateSurveyPolls')"
              x-small
              icon
              class="mr-2"
              v-bind="attrs"
              v-on="on"
              @click.stop.prevent="onEditSurvey(item)"
            >
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
          </template>
          <span>
            {{
              item.type === "survey"
                ? $t("poll.tipEditSurvey")
                : $t("poll.tipEditPoll")
            }}</span
          >
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-if="$security.checkUserAccess('DeleteSurveyPolls')"
              x-small
              icon
              v-bind="attrs"
              v-on="on"
              class="mr-2"
              @click.stop.prevent="onDeleteSurvey(item)"
            >
              <v-icon>mdi-delete</v-icon>
            </v-btn>
          </template>
          <span>
            {{
              item.type === "survey"
                ? $t("poll.tipDeleteSurvey")
                : $t("poll.tipDeletePoll")
            }}</span
          >
        </v-tooltip>
        <v-tooltip bottom v-if="$security.checkUserAccess('CreateSurveyPolls')">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-if="$security.checkUserAccess('CreateSurveyPolls')"
              x-small
              icon
              v-bind="attrs"
              v-on="on"
              @click.stop.prevent="copySurvey(item)"
            >
              <v-icon>mdi-content-copy</v-icon>
            </v-btn>
          </template>
          <span>
            {{
              item.type === "survey"
                ? $t("poll.tipCopySurvey")
                : $t("poll.tipCopyPoll")
            }}</span
          >
        </v-tooltip>
        <v-tooltip
          bottom
          v-if="
            $security.checkUserAccess('UpdateSurveyPolls') &&
            (item.surveyStatus.value === 'upcoming' ||
              item.surveyStatus.value === 'active')
          "
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              small
              icon
              v-bind="attrs"
              v-on="on"
              @click.stop.prevent="remindAlertDialog"
              class="ml-2"
            >
              <v-icon>mdi-email-outline</v-icon>
            </v-btn>
          </template>
          <span> {{ $t("poll.remindAlertTooltip") }}</span>
        </v-tooltip>
      </v-toolbar>
      <v-list-item :key="item.title" :value="item" class="pr-0">
        <template v-slot:default="{}">
          <v-list-item-content class="pt-0">
            <h3 class="title-overflow mb-3">
              {{ item.question || item.title }}
            </h3>
            <span class="subtitl surveydates pb-1">
              <strong
                ><span v-if="item.surveyStatus.value === 'upcoming'">{{
                  $t("poll.lblStartsOn")
                }}</span>
                <span v-else>{{ $t("poll.lblStartedOn") }}</span>
                :</strong
              >
              {{ item.commencementDate }}
            </span>
            <span class="subtitle surveydates">
              <strong
                ><span v-if="item.surveyStatus.value === 'expired'">{{
                  $t("poll.lblExpiredOn")
                }}</span>
                <span v-else>{{ $t("poll.lblExpiresOn") }}</span>
                :</strong
              >
              {{ item.expiryDate }}
            </span>

            <div v-if="item.type === 'survey1'">
              <v-progress-linear
                v-model="progressBar"
                color="light-blue"
                height="10"
                value="33"
                striped
              >
              </v-progress-linear>
              <span class="vote-label">
                {{ Math.ceil(progressBar) }}% {{ $t("poll.lblComplete") }}</span
              >
            </div>
          </v-list-item-content>

          <v-list-item-action class="pa-0 ma-0">
            <!-- <v-btn color="grey" dark icon>
                                  <v-icon>mdi-dots-vertical</v-icon>
                                </v-btn> -->

            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <a-chip
                  v-bind="attrs"
                  v-on="on"
                  class="label-s"
                  small
                  outlined
                  :color="item.surveyStatus.color"
                >
                  {{ item.surveyStatus.text }}
                </a-chip>
              </template>
              <span v-html="getSurveyStatus(item.surveyStatus)"> </span>
            </v-tooltip>
          </v-list-item-action>
        </template>
      </v-list-item>
      <v-divider v-if="!shownOnDashboard" class="ma-0"></v-divider>
      <v-list-item dense v-if="!shownOnDashboard">
        <span class="subtitle surveydates"
          ><strong>{{ $t("admin.createdBy") }}:</strong> {{ item.userid }}</span
        >
      </v-list-item>
      <!-- <v-divider v-if="index < items.length - 1" :key="index"></v-divider>
        </template>
      </v-list-item-group>
    </v-list> -->
    </v-card-text>
    <confirm-dialog ref="confirmDelete" />
    <email-alert-notification
      v-if="$security.checkUserAccess('UpdateSurveyPolls') && dialogRemind"
      v-model="dialogRemind"
      :emailTemplate="emailTemplate"
      :defaulter="defaulter"
      type="remind"
      section="survey"
      :suggestedList="suggestedAttendees"
      @send="onEmailSend"
    ></email-alert-notification>
  </v-card>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import ConfirmDialog from "../ConfirmDialog.vue";
import customFunctions from "@/codeFiles/taskHelper.js";
import RespondedMsg from "./RespondedMsg.vue";
import EmailAlertNotification from "@/components/EmailAlertNotification.vue";
import Loader from "@/components/Loader.vue";
import { formatDate as toDateConvert } from "../../utils/util";

export default {
  components: { ConfirmDialog, RespondedMsg, EmailAlertNotification, Loader },
  name: "SurveyCard",
  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
    shownOnDashboard: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      progressBar: 33,
      dialogRemind: false,
      defaulter: [],
      suggestedAttendees: [],
    };
  },
  computed: {
    ...mapGetters({
      getTemplateByTemplateTypeId: "tenant/getTemplateByTemplateTypeId",
    }),
    tenantId() {
      return sessionStorage.getItem("tenantId");
    },
    tenantName() {
      const users = this.$auth.user[process.env.VUE_APP_TENANT_KEY];
      const tenant = users.find((u) => u.id === this.tenantId);
      if (tenant) {
        return tenant.name;
      }
      return this.tenantId;
    },
    LoaderText() {
      return this.$t("LoaderText");
    },
    daysInexpire() {
      const diffInMs = new Date(this.item.endDate) - new Date();
      const diffInDays = Math.round(diffInMs / (1000 * 60 * 60 * 24));
      return diffInDays;
    },
    getSurveyTemplate() {
      return this.getTemplateByTemplateTypeId("Survey",  this.selectedLang);
    },
    selectedLang() {
      return this.$i18n.locale;
    },
    dateFormat() {
      return this.selectedLang !== "ja" ? "dd/MM/yyyy" : "yyyy/MM/dd";
    },
    emailTemplate() {
      const placeHolderVariables = {
        "{{%date%}}": this.item.commencementDate,
        "{{%tenant%}}": this.tenantName,
        "{{%survey_name%}}": this.item.title,
        "{{%survey_expiry_days%}}": this.daysInexpire,
        "{{%survey_end_date%}}": toDateConvert(
          new Date(this.item.endDate),
          this.dateFormat
        ),
        "{{%survey_start_date%}}": toDateConvert(
          new Date(this.item.startDate),
          this.dateFormat
        ),
      };
      return {
        subject: this.getSurveyTemplate.subject.replace(
          /{{%[^}]+%}}/g,
          (match) => placeHolderVariables[match] || ""
        ),
        message: this.getSurveyTemplate.body.replace(
          /{{%[^}]+%}}/g,
          (match) => placeHolderVariables[match] || ""
        ),
        mailType: "survey-alert",
        dynamicVariables: {
          targetId: this.item.id,
          targetTitle: this.item.title,
          meetingTypeId: this.getMeetingTypeId,
          targetLinkLabel: this.$t("poll.surveyTargetLinkLabel"),
          targetLink: `${window.location.origin}/survey/${this.item.id}/tenant/${this.tenantId}/survey`,
        },
      };
    },
  },
  methods: {
    ...mapActions({
      deleteSurvey: "poll/deleteSurvey",
      getSurveyRespondersDetails: "poll/getSurveyRespondersDetails",
    }),
    getDateWords,
    onDeleteSurvey,
    copySurvey,
    ConfirmDelete,
    onEditSurvey,
    onEmailSend(isSucess) {
      if (isSucess) {
        this.$store.commit("setAlert", {
          variant: "success",
          message: this.$t("agenda.SendEmailNotification"),
        });
      } else {
        this.$store.commit("setAlert", {
          variant: "success",
          message: this.$t("agenda.FaildEmailNotification"),
        });
      }
    },
    getSurveyStatus(item) {
      if (item.value) {
        return this.$t(`poll.${item.value}`);
      }
    },
    shadeColor(color, percentage) {
      return customFunctions.shadeColor(color, percentage);
    },
    navigateToSurveyDetails(item) {
      let navigateUrl = "";
      if (
        item.surveyStatus.value !== "upcoming" ||
        this.$security.checkUserAccess("CreateSurveyPolls")
      ) {
        const currentRoute = this.$route.name;
        switch (currentRoute) {
          case "Calendar":
            navigateUrl = `/survey/${item.id}/tenant/${this.tenantId}/calendar`;
            break;
          case "dashboard":
            navigateUrl = `/survey/${item.id}/tenant/${this.tenantId}/dashboard`;
            break;
          default:
            navigateUrl = `/survey/${item.id}/tenant/${this.tenantId}/survey`;
            break;
        }
      }
      return navigateUrl;
    },
    async remindAlertDialog() {
      try {
        const response = await this.getSurveyRespondersDetails(this.item.id);
        this.suggestedAttendees = response.all
          ? response.all.map((v) => ({ ...v, email: v.registered_email }))
          : [];
        this.defaulter = response.defaulters
          ? response.defaulters.map((v) => ({
              ...v,
              email: v.registered_email,
            }))
          : [];

        this.dialogRemind = true;
      } catch (error) {
        console.log(error, "api error");
      }
    },
  },
};

function onEditSurvey(item) {
  const currentRoute = this.$route.name;
  switch (currentRoute) {
    case "Calendar":
      this.$router.push(`/${item.type}/add/${item.id}/calendar`);
      break;
    case "dashboard":
      this.$router.push(`/${item.type}/add/${item.id}/dashboard`);
      break;
    default:
      this.$router.push(`/${item.type}/add/${item.id}/survey`);
      break;
  }
}

async function onDeleteSurvey(item) {
  const answer = await this.ConfirmDelete();
  if (answer) {
    await this.deleteSurvey(item.id);
    this.surveyQuestions = null;
    this.$store.commit("setAlert", {
      variant: "success",
      message:
        item.type == "survey"
          ? this.$t("poll.SurveyDeleteSuccess")
          : this.$t("poll.PollDeleteSuccess"),
    });
  }
}

async function copySurvey(item) {
  if (
    await this.$refs.confirmDelete.open(
      this.$t("lblConfirm"),
      this.$t("poll.hCopyMessage")
    )
  ) {
    const currentRoute = this.$route.name;
    switch (currentRoute) {
      case "Calendar":
        this.$router.push(`/${item.type}/add/copy/calendar/${item.id}`);
        break;
      case "dashboard":
        this.$router.push(`/${item.type}/add/copy/dashboard/${item.id}`);
        break;
      default:
        this.$router.push(`/${item.type}/add/copy/survey/${item.id}`);
        break;
    }
  }
}

async function ConfirmDelete() {
  if (
    await this.$refs.confirmDelete.open(
      this.$t("agenda.hDeleteMessage"),
      this.$t("agenda.lblDeleteMessage")
    )
  ) {
    return true;
  }
}

function getDateWords(paramData) {
  const endDate = new Date(paramData);

  const movingDate = new Date();
  // movingDate.setDate(movingDate.getDate() + 1);

  const today = new Date();
  const tomorrow = new Date(movingDate.setDate(movingDate.getDate() + 1));
  const nexDay1 = new Date(movingDate.setDate(movingDate.getDate() + 1));
  const nexDay2 = new Date(movingDate.setDate(movingDate.getDate() + 1));
  const nexDay3 = new Date(movingDate.setDate(movingDate.getDate() + 1));
  const nexDay4 = new Date(movingDate.setDate(movingDate.getDate() + 1));
  const nexDay5 = new Date(movingDate.setDate(movingDate.getDate() + 1));
  const nextWeek = new Date(movingDate.setDate(movingDate.getDate() + 1));

  if (endDate < today) return "Today " + formatDate(endDate, "h:mm aaa");
  if (endDate < tomorrow) return "Tomorrow " + formatDate(endDate, "h:mm aaa");
  if (endDate < nexDay1) return dayOfWeekNames[endDate.getDay()];
  if (endDate < nexDay2) return dayOfWeekNames[endDate.getDay()];
  if (endDate < nexDay3) return dayOfWeekNames[endDate.getDay()];
  if (endDate < nexDay4) return dayOfWeekNames[endDate.getDay()];
  if (endDate < nexDay5) return dayOfWeekNames[endDate.getDay()];
  if (endDate < nextWeek) return "Next Week";

  return formatDate(new Date(), "MM/dd/yyyy h:mm aaa");
}

const monthNames = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];
const dayOfWeekNames = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
];

function formatDate(date, patternStr) {
  if (!patternStr) {
    patternStr = "M/d/yyyy";
  }
  var day = date.getDate(),
    month = date.getMonth(),
    year = date.getFullYear(),
    hour = date.getHours(),
    minute = date.getMinutes(),
    second = date.getSeconds(),
    miliseconds = date.getMilliseconds(),
    h = hour % 12,
    hh = twoDigitPad(h),
    HH = twoDigitPad(hour),
    mm = twoDigitPad(minute),
    ss = twoDigitPad(second),
    aaa = hour < 12 ? "AM" : "PM",
    EEEE = dayOfWeekNames[date.getDay()],
    EEE = EEEE.substr(0, 3),
    dd = twoDigitPad(day),
    M = month + 1,
    MM = twoDigitPad(M),
    MMMM = monthNames[month],
    MMM = MMMM.substr(0, 3),
    yyyy = year + "",
    yy = yyyy.substr(2, 2);
  // checks to see if month name will be used
  patternStr = patternStr
    .replace("hh", hh)
    .replace("h", h)
    .replace("HH", HH)
    .replace("H", hour)
    .replace("mm", mm)
    .replace("m", minute)
    .replace("ss", ss)
    .replace("s", second)
    .replace("S", miliseconds)
    .replace("dd", dd)
    .replace("d", day)

    .replace("EEEE", EEEE)
    .replace("EEE", EEE)
    .replace("yyyy", yyyy)
    .replace("yy", yy);
  // .replace("aaa", aaa);
  if (patternStr.indexOf("MMM") > -1) {
    patternStr = patternStr.replace("MMMM", MMMM).replace("MMM", MMM);
  } else {
    patternStr = patternStr.replace("MM", MM).replace("M", M);
  }
  return patternStr.replace("aaa", aaa);
}

function twoDigitPad(num) {
  return num < 10 ? "0" + num : num;
}
</script>

<style scoped>
::v-deep .surveydates {
  font-size: smaller !important;
  color: gray;
}

.title-overflow {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  line-height: 1.5 !important;
}
</style>
